import { safeURLPath } from './safe-url-path';

export interface BasePathOptions {
    basePath: string;
}

export const getBaseURLPath = safeURLPath(({ basePath }: BasePathOptions) => [
    basePath
]);
